<template>
  <div id="interaction">
    <img src="../../../assets/enterprise/from-banner.png" alt="" />
    <van-tabs
      style="margin-top:-8px;"
      v-model="process"
      color="#0084FF"
      :line-width="100"
      title-active-color="#0084FF"
      :before-change="onClickTab"
      @click="buriedPoint"
    >
      <van-tab title="待填报"> </van-tab>
      <van-tab title="已完成"></van-tab>
      <van-tab title="已过期"></van-tab>
    </van-tabs>
    <van-empty class="empty" v-if="list.length <= 0" description="暂无数据" />
    <div
      v-else
      class="interaction-list"
      v-for="(item, index) in list"
      @click="Jump(item)"
      :key="index"
    >
      <div class="list-title">{{ item.name }}</div>
      <div class="list-time">填报时间：{{ item.createTime }}</div>
      <img :src="item.covers" alt="" />
    </div>
  </div>
</template>

<script>
import * as API from '@api/lishui/index'
import { saveRecord, saveUVRecord } from '@api/lishui'
import { Empty } from 'vant'
import {
  getUrlParam,
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage
} from '@utils'
export default {
  name: 'Interaction',
  props: {},
  data() {
    return {
      creditCode: '',
      staffName: '',
      staffType: '',
      mobile: '',
      addresss: '',
      postOffice: '',
      entName: '',
      list: [],
      process: 0,
      token: ''
    }
  },
  created() {},
  mounted() {
    setTimeout(() => {
      const user = JSON.parse(getLocalStorage('lishuiUserInfo'))
      console.log(user)
      this.creditCode = user.creditCode
      this.staffName = user.staffName
      this.staffType = user.staffType
      this.mobile = user.mobile
      this.addresss = user.addresss
      this.postOffice = user.postOffice
      this.entName = user.entName
      if (this.creditCode) {
        this.getformlist()
      }
    }, 400)
  },
  watch: {
    $route: {
      handler: function(val, oldVal) {
        this.getformlist()
      },
      // 深度观察监听
      deep: true
      // 判断逻辑
    }
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.creditCode,
        entName: this.entName,
        mobile: this.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      saveRecord(params).then(res => {})
      saveUVRecord(params).then(res => {})
    },
    getformlist() {
      // console.log(this.creditCode)
      const params = {
        creditCode: this.creditCode,
        phone: this.mobile,
        type: this.process + 1
      }
      API.listMyForm(params).then(res => {
        this.list = res.data.data || []
      })
    },
    Jump(text) {
      this.buriedPoint()
      window.location.href =
        text.phoneUrl +
        '&creditCode=' +
        this.creditCode +
        '&staffName=' +
        this.staffName +
        '&staffType=' +
        this.staffType +
        '&mobile=' +
        this.mobile +
        '&addresss=' +
        this.addresss +
        '&postOffice=' +
        this.postOffice +
        '&entName=' +
        this.entName
    },
    // nav
    onClickTab(title) {
      this.process = title
      this.getformlist()
    }
  },
  components: {}
}
</script>

<style lang="scss" scoped>
#interaction {
  width: 100%;
  height: 100%;
  background-color: #fff;
  position: relative;
  img {
    width: 100%;
    height: 140px;
  }
  .interaction-list {
    padding: 15px 15px 20px;
    border-bottom: 1px solid #e2e2e2;
    .list-title {
      font-size: 16px;
      color: #333333;
      margin-bottom: 4px;
    }
    .list-time {
      font-size: 12px;
      color: #999999;
    }
    img {
      width: 345px;
      height: 85px;
      margin-top: 13px;
    }
  }
  .empty {
    margin-top: 150px;
    // position: absolute;
    // top: 200px;
    // bottom: 0;
    // left: 0;
    // right: 0;
  }
}
</style>
